import { useEffect } from "react";

import { MOBILE_APP } from "../../config/mobileApp";

/**
 * Meta tags pentru promovarea app-ului când universal links / assetlinks
 * nu sunt (încă) recunoscute de OS (ex. cache vechi după ștergerea .well-known).
 */
const MobileAppHead = () => {
  useEffect(() => {
    const tags: HTMLMetaElement[] = [];

    const addMeta = (name: string, content: string) => {
      const el = document.createElement("meta");
      el.name = name;
      el.content = content;
      document.head.appendChild(el);
      tags.push(el);
    };

    addMeta(
      "apple-itunes-app",
      `app-id=${MOBILE_APP.ios.appStoreId}, app-argument=${window.location.href}`,
    );
    addMeta("apple-mobile-web-app-capable", "yes");
    addMeta("mobile-web-app-capable", "yes");

    return () => {
      tags.forEach((el) => el.remove());
    };
  }, []);

  return null;
};

export default MobileAppHead;
